import PropTypes from 'prop-types'
import { Box } from '@mui/material'
import Toast from './Toast'

export default function ToastContainer({ toasts, removeToast }) {
  return (
    <Box
      sx={{
        bottom: 24,
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
        position: 'fixed',
        right: 24,
        zIndex: 9999,
      }}
    >
      {toasts.map((toast) => (
        <Toast
          key={toast.id}
          toast={toast}
          onClose={() => removeToast(toast.id)}
        />
      ))}
    </Box>
  )
}

ToastContainer.propTypes = {
  toasts: PropTypes.array.isRequired,
  removeToast: PropTypes.func.isRequired,
}
